import React, { FC } from 'react';
import { LinkMenuItem as BaseLinkMenuItem } from '@prime/core';
import { useTranslation } from 'react-i18next';

interface LinkMenuItemProps {
  label: string;
  to: string;
}

const LinkMenuItem: FC<LinkMenuItemProps> = (props) => {
  const { t } = useTranslation();

  return <BaseLinkMenuItem to={props.to}>{t(props.label)}</BaseLinkMenuItem>;
};

export default LinkMenuItem;
